import getProductSamples from 'services/api/samples/getProductSamples';

export default {
    getProductSamples
};
